import React from 'react';

export const SI = () => {
	return (
		<svg
			width='20'
			height='15'
			viewBox='0 0 20 15'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g clipPath='url(#clip0_11534_5935)'>
				<mask
					id='mask0_11534_5935'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='0'
					y='0'
					width='20'
					height='15'
				>
					<rect width='20' height='15' fill='white' />
				</mask>
				<g mask='url(#mask0_11534_5935)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 0V15H20V0H0Z'
						fill='#2E42A5'
					/>
					<mask
						id='mask1_11534_5935'
						style={{ maskType: 'luminance' }}
						maskUnits='userSpaceOnUse'
						x='0'
						y='0'
						width='20'
						height='15'
					>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M0 0V15H20V0H0Z'
							fill='white'
						/>
					</mask>
					<g mask='url(#mask1_11534_5935)'>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M0 0V5H20V0H0Z'
							fill='#F7FCFF'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M0 10V15H20V10H0Z'
							fill='#C51918'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M8.58765 3.14767C8.58765 3.14767 7.27219 2.52646 5.63607 2.52646C3.99994 2.52646 2.68448 3.14767 2.68448 3.14767C2.68448 3.14767 2.83087 5.64436 3.06225 6.96699C3.16104 7.53171 3.63587 8.35536 4.06575 8.74521C4.55573 9.18955 5.63607 9.71598 5.63607 9.71598C5.94869 9.50056 6.53323 9.40368 7.28038 8.74521C8.02753 8.08673 8.21323 6.96699 8.21323 6.96699L8.58765 3.14767Z'
							fill='#2E42A5'
						/>
						<path
							d='M8.41374 3.06607L8.96157 3.33965L8.5855 7.10379C8.45378 7.90045 8.12421 8.5287 7.59716 8.9932C7.31125 9.24517 7.03217 9.43344 6.73296 9.58988C6.56407 9.67818 5.8576 10.0421 5.86376 10.0391C5.79298 10.0732 5.7393 10.1031 5.6957 10.1332L5.62737 10.1802L5.5536 10.1443C4.82187 9.78774 4.13918 9.3079 3.79992 9.00024C3.33681 8.58026 2.84851 7.72085 2.7444 7.12576C2.58875 6.23597 2.44916 5.01041 2.3512 3.33965L2.84332 3.08219C2.94055 4.74036 3.05791 6.06218 3.21076 6.9359C3.30119 7.45283 3.75147 8.24533 4.16224 8.61784C4.46582 8.89315 4.95491 9.19843 5.62737 9.53043C5.66748 9.50692 5.71194 9.48366 5.76279 9.45915C5.76422 9.45845 6.22167 9.25531 6.38065 9.17219C6.65949 9.0264 6.91867 8.85156 7.18552 8.61638C7.65338 8.20404 7.94539 7.64874 8.06348 6.94331L8.41374 3.06607Z'
							fill='#C51918'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M3.46378 6.89015C3.46378 6.89015 3.58301 7.25494 3.80345 7.66462C4.12717 7.74999 4.32525 7.7455 4.38785 7.67542C4.56897 7.4727 5.21337 7.38608 5.33361 7.55925C5.40779 7.66609 5.66852 7.73995 5.95362 7.64223L5.92184 7.64785C5.97136 7.62985 6.08735 7.58387 6.15885 7.55553L6.21707 7.53258C6.3244 7.49208 6.40327 7.47082 6.48361 7.46485C6.58432 7.45736 6.6809 7.47611 6.78323 7.52484C7.00817 7.63194 7.28572 7.68185 7.47473 7.64942C7.70576 7.24703 7.87051 6.89015 7.87051 6.89015L6.77345 5.83728L6.33741 6.31045L5.61293 5.27759L5.00639 6.31045L4.5413 5.83728L3.46378 6.89015ZM4.098 8.13409C4.04736 8.06581 3.9995 7.99525 3.95451 7.92406C4.2353 7.97526 4.42596 7.94834 4.53203 7.82962C4.58213 7.77354 4.73078 7.71916 4.89991 7.69643C4.97876 7.68583 5.05441 7.68319 5.11241 7.68872C5.13902 7.69126 5.16047 7.69542 5.17491 7.70041C5.17959 7.70203 5.17944 7.70182 5.17459 7.69487L5.17371 7.69361C5.30304 7.87852 5.65414 7.97763 5.98541 7.85719L5.95362 7.86281C6.04323 7.83527 6.20461 7.77181 6.26261 7.74901L6.2828 7.74111C6.37477 7.70641 6.43816 7.68932 6.49728 7.68493C6.56546 7.67986 6.6298 7.69235 6.70278 7.7271C6.90197 7.82195 7.13352 7.87838 7.33761 7.87984C7.2941 7.9502 7.24918 8.02018 7.20335 8.08817C7.0447 8.12499 6.79926 8.07658 6.60127 7.96846C6.50872 7.91793 6.42035 7.89825 6.3282 7.90611C6.25534 7.91232 6.18468 7.93415 6.08923 7.97546C6.08366 7.97787 6.06407 7.98677 6.03768 7.99877C5.97525 8.02715 5.8748 8.0728 5.83204 8.09063L5.86794 8.0834C5.62016 8.17898 5.40327 8.10852 5.34135 8.00624C5.23085 7.82372 4.65171 7.913 4.48878 8.12215C4.44534 8.17791 4.31425 8.18809 4.098 8.13409ZM4.31362 8.38968C4.32583 8.40222 4.33816 8.41457 4.3506 8.4267C4.9151 8.97711 5.61293 9.24691 5.61293 9.24691C5.61293 9.24691 6.4441 8.99539 6.91583 8.46586C6.95609 8.42068 6.99642 8.37174 7.03653 8.32C6.8645 8.31149 6.6754 8.25547 6.51124 8.16583C6.45091 8.13289 6.39898 8.12133 6.34386 8.12603C6.29511 8.13018 6.24173 8.14668 6.16338 8.18058C6.16127 8.1815 6.15615 8.1838 6.14862 8.18719C6.10065 8.2088 5.95495 8.2744 5.86794 8.30399L5.90384 8.29676C5.61183 8.41851 5.30179 8.32239 5.18087 8.14004C5.17015 8.13582 5.15334 8.1321 5.13203 8.12977C5.08351 8.12446 5.01945 8.12702 4.95248 8.13735C4.80898 8.15947 4.68366 8.21205 4.64221 8.26524C4.57254 8.35468 4.46328 8.39418 4.31362 8.38968Z'
							fill='white'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M4.46676 3.6789H4.02731L4.36815 3.3596L4.02731 3.02219H4.46676L4.65231 2.69467L4.83861 3.02219H5.27731L4.95352 3.33933L5.24103 3.6789H4.83861L4.65231 4.02452L4.46676 3.6789Z'
							fill='#FECA00'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M6.53785 3.6789H6.0984L6.43924 3.3596L6.0984 3.02219H6.53785L6.7234 2.69467L6.9097 3.02219H7.3484L7.02461 3.33933L7.31212 3.6789H6.9097L6.7234 4.02452L6.53785 3.6789Z'
							fill='#FECA00'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M5.37495 4.72968H4.9355L5.27634 4.41038L4.9355 4.07297H5.37495L5.5605 3.74545L5.7468 4.07297H6.1855L5.8617 4.39011L6.14922 4.72968H5.7468L5.5605 5.0753L5.37495 4.72968Z'
							fill='#FECA00'
						/>
					</g>
				</g>
			</g>
			<rect
				x='0.5'
				y='0.5'
				width='19'
				height='14'
				rx='1'
				stroke='black'
				strokeOpacity='0.1'
			/>
			<defs>
				<clipPath id='clip0_11534_5935'>
					<rect width='20' height='15' rx='1.5' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};
